import PropTypes from "prop-types";
import { HiPlus } from "react-icons/hi2";
import "../shared/primaryButton.css";

function PrimaryButton({
  children,
  showPlus = false,
  className = "",
  type = "button",
  ...rest
}) {
  return (
    <button
      type={type}
      className={["sd-primary-btn", className].filter(Boolean).join(" ")}
      {...rest}
    >
      {showPlus && <HiPlus className="sd-primary-btn__icon" strokeWidth={2} aria-hidden />}
      {children}
    </button>
  );
}

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  showPlus: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
};

export default PrimaryButton;
